"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Success = void 0;
var React = require("react");
var Success = function () { return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
    React.createElement("defs", null,
        React.createElement("path", { d: "M18.3,6.3 L9,15.6 L5.7,12.3 C5.3,11.9 4.7,11.9 4.3,12.3 C3.9,12.7 3.9,13.3 4.3,13.7 L8.3,17.7 C8.5,17.9 8.7,18 9,18 C9.3,18 9.5,17.9 9.7,17.7 L19.7,7.7 C20.1,7.3 20.1,6.7 19.7,6.3 C19.3,5.9 18.7,5.9 18.3,6.3 Z", id: "SUCCESS-SVG-ICON-PATH1" })),
    React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        React.createElement("mask", { id: "SUCCESS-SVG-ICON-mask-2", fill: "white" },
            React.createElement("use", { xlinkHref: "#SUCCESS-SVG-ICON-PATH1" })),
        React.createElement("g", { fillRule: "nonzero" }),
        React.createElement("g", { mask: "url(#SUCCESS-SVG-ICON-mask-2)", fill: "#00242D" },
            React.createElement("rect", { x: "0", y: "0", width: "24", height: "24" }))))); };
exports.Success = Success;
//# sourceMappingURL=Success.js.map